import { Identifiable, Resource } from "@planzone/dto";
import { Filter } from "@planzone/dto";

import { isFilteredByResources } from "./resources";
import { isFilteredByTags } from "./resourceTags";
import { isFilteredByGroups } from "./groups";

function isResourceFiltered(
  resource: Identifiable<Resource>,
  filter: Filter,
): boolean {
  return [isFilteredByResources, isFilteredByGroups, isFilteredByTags].reduce(
    (isFiltered, applyFilter) =>
      isFiltered ? isFiltered : applyFilter(resource, filter),
    false,
  );
}

export { isResourceFiltered };
